/**
 * @classdesc Classe utilitária para agrupar métodos de manipulação e consulta do DOM (Document Object Model) HTML.
 */
export default class DOMUtil {
    /**
     * Indica se o recurso está disponível ou não.
     *
     * @public
     * @static
     * @param {string} src A localização do recurso (URL).
     * @returns {boolean} Um sinalizador que indica se o recurso está disponível (true) ou não (false).
     */
    static verificarScriptIncluido(src) {
        let scripts = document.getElementsByTagName('script');
        for (const script of scripts) {
            if (script.getAttribute('src') === src) {
                return true;
            }
        }
        return false;
    }
}
